import React from "react"
import classes from "./CheckboxFilterTag.module.css"
import { CloseFab } from "../../../../../ui/atoms/Fab"
import { FilterCategory, CheckboxFilterOption } from "../types"

interface Props {
  category: FilterCategory
  option: CheckboxFilterOption
  onRemove: () => void
}

const getLabel = (option: CheckboxFilterOption, category: FilterCategory) => {
  switch (option.type) {
    case "bool":
      return option.code === "false" ? `${category.name}: no` : category.name
    default:
      return option.label
  }
}

const CheckboxFilterTag = ({ category, option, onRemove }: Props) => {
  return (
    <div className={classes.root}>
      {getLabel(option, category)}
      <CloseFab
        colorValue="transparent"
        size="small"
        className={classes.close}
        iconClassName={classes.closeIcon}
        onClick={onRemove}
      />
    </div>
  )
}

export default CheckboxFilterTag
